import EnterpriseComponentAttributeMetadata from "../../EnterpriseComponentAttributeMetadata";
import EnterpriseComponentMetadata from "../../EnterpriseComponentMetadata";

// One dashboard, as a row.
//
// BOTH REGISTRIES OR NEITHER. EnterpriseComponentClassFactory maps the name to a CLASS and
// EnterpriseComponentMetadataClassFactory maps it to THIS -- registering only the first gets
// "metadataClass is not a constructor", which is a BLANK PAGE rather than a degraded grid, because
// the missing name returns undefined and the constructor calls `new undefined()`. It has happened
// in this app twice.
//
// EVERYTHING IS A String, including the tile count: these are for display, the server did the
// counting, and a number re-parsed in the browser is a second answer waiting to disagree.
class DashboardEnterpriseComponentMetadata extends EnterpriseComponentMetadata {
    constructor() {
        super();

        this.name = "Dashboard";
        this.defaultCacheSize = 50;

        this.attributes["USID"] = new EnterpriseComponentAttributeMetadata(
            "USID", false, false, false, false, null, null, null, null, null, null, "UUID", null, false,
        );

        for (const [name, size] of [["Name", 400], ["Description", 4000], ["Tiles", 20]]) {
            this.attributes[name] = new EnterpriseComponentAttributeMetadata(
                name, false, false, false, false, null, null, null, size, null, null,
                "String", null, false,
            );
        }

        // WHERE THE ROW GOES, declared rather than smuggled: the grid reads every cell through the
        // EC, and an attribute the metadata does not know is not readable there. Underscored
        // because it is not one of the reader's columns and must never be headed as one.
        this.attributes["_href"] = new EnterpriseComponentAttributeMetadata(
            "_href", false, false, false, false, null, null, null, 1000, null, null,
            "String", null, false,
        );
    }
}

export default DashboardEnterpriseComponentMetadata;
